import Vue from 'vue';
import endpoints from "./endpoints";

export default {
	install(app, options){
			const self = this;

			
			Vue.prototype.$api = {
				apiBaseUrl: endpoints.base_url
			}

			Vue.prototype.$apiEndpoints = {
				login: function(){
					return endpoints.base_url + endpoints.auth.login;
				},
				refresh: function(){
					return endpoints.base_url + endpoints.auth.refresh;
				},
				userList: function(){
					return endpoints.base_url + endpoints.users.index;
				},
				userCreate: function(){
					return endpoints.base_url + endpoints.users.create;
				},
				userUpdate: function(user_id){
					return endpoints.base_url + endpoints.users.update.replace(/:user_id/g, user_id);
				},
				userDelete: function(user_id){
					return endpoints.base_url + endpoints.users.delete.replace(/:user_id/g, user_id);
				},
				userShow: function(user_id){
					return endpoints.base_url + endpoints.users.show.replace(/:user_id/g, user_id);
				},
				userMoneyboxAssignmentCreate: function(user_id){
					return endpoints.base_url + endpoints.users.moneybox_assignment.create.replace(/:user_id/g, user_id);
				},
				userMoneyboxAssignmentDelete: function(user_id, moneybox_id){
					return endpoints.base_url + endpoints.users.moneybox_assignment.delete.replace(/:user_id/g, user_id).replace(/:moneybox_id/g, moneybox_id);
				},
				userMoneyboxAssignmentIndex: function(user_id){
					return endpoints.base_url + endpoints.users.moneybox_assignment.index.replace(/:user_id/g, user_id);
				},
				userSegmentAssignmentCreate: function(user_id){
					return endpoints.base_url + endpoints.users.segment_assignment.create.replace(/:user_id/g, user_id);
				},
				userSegmentAssignmentIndex: function(user_id){
					return endpoints.base_url + endpoints.users.segment_assignment.index.replace(/:user_id/g, user_id);
				},
				moneyboxList: function(){
					return endpoints.base_url + endpoints.moneyboxes.index;
				},
				moneyboxCreate: function(){
					return endpoints.base_url + endpoints.moneyboxes.create;
				},
				moneyboxUpdate: function(moneybox_id){
					return endpoints.base_url + endpoints.moneyboxes.update.replace(/:moneybox_id/g, moneybox_id);
				},
				moneyboxShow: function(moneybox_id){
					return endpoints.base_url + endpoints.moneyboxes.show.replace(/:moneybox_id/g, moneybox_id);
				},
				moneyboxDelete: function(moneybox_id){
					return endpoints.base_url + endpoints.moneyboxes.delete.replace(/:moneybox_id/g, moneybox_id);
				},
				moneyboxUnloadIntervalCreate: function(moneybox_id){
					return endpoints.base_url + endpoints.moneyboxes.unload_interval.create.replace(/:moneybox_id/g, moneybox_id);
				},				
				user: function(){
					return endpoints.base_url + endpoints.user.show;
				},
				userSegmentInfo: function(){
					return endpoints.base_url + endpoints.user.segment_info;
				},
				userMoneyboxUnloads: function(){
					return endpoints.base_url + endpoints.user.moneybox_unloads;
				},
				corporationList: function(){
					return endpoints.base_url + endpoints.corporations.index;
				},
				corporationCreate: function(){
					return endpoints.base_url + endpoints.corporations.create;
				},
				corporationDelete: function(corporation_id){
					return endpoints.base_url + endpoints.corporations.delete.replace(/:corporation_id/g, corporation_id);
				},
				corporationShow: function(corporation_id){
					return endpoints.base_url + endpoints.corporations.show.replace(/:corporation_id/g, corporation_id);
				},
				corporationUpdate: function(corporation_id){
					return endpoints.base_url + endpoints.corporations.update.replace(/:corporation_id/g, corporation_id);
				},
				corporationMoneyboxAssignmentCreate: function(corporation_id){
					return endpoints.base_url + endpoints.corporations.moneybox_assignment.create.replace(/:corporation_id/g, corporation_id);
				},
				corporationMoneyboxAssignmentDelete: function(corporation_id, assignment_id){
					return endpoints.base_url + endpoints.corporations.moneybox_assignment.delete.replace(/:corporation_id/g, corporation_id).replace(/:assignment_id/g, assignment_id);
				},
				reportsBasic: function(){
					return endpoints.base_url + endpoints.reports.basic;
				},
				reportsMoneyboxUnloadState: function(){
					return endpoints.base_url + endpoints.reports.moneybox_unload_state;
				},
				reportsOverdueMoneyboxes: function(){
					return endpoints.base_url + endpoints.reports.overdue_moneyboxes;
				},
				reportsDataQuality: function(){
					return endpoints.base_url + endpoints.reports.data_quality;
				},
				reportsSegmentBreakdown: function(){
					return endpoints.base_url + endpoints.reports.segment_breakdown;
				},
				reportsUnloadTrend: function(granularity){
					return endpoints.base_url + endpoints.reports.unload_trend + '?granularity=' + (granularity || 'week');
				},
				reportsUserPerformance: function(){
					return endpoints.base_url + endpoints.reports.user_performance;
				},
				segmentIndex: function(){
					return endpoints.base_url + endpoints.segments.index;
				},
				segmentTypeIndex: function(){
					return endpoints.base_url + endpoints.segments.types.index;
				},
				segmentCreate: function(){
					return endpoints.base_url + endpoints.segments.create;
				},
				segmentDelete: function(segment_id) {
					return endpoints.base_url + endpoints.segments.delete.replace(/:segment_id/g, segment_id);
				},
				segmentMyPath: function() {
					return endpoints.base_url + endpoints.segments.my_path;
				}
			}
		}
};